import { Flex } from "@redotech/arbiter/flex";
import { Text } from "@redotech/arbiter/text";
import Logo from "@redotech/redo-web/logo-wordmark.svg";
import { memo } from "react";

import * as css from "./top-nav.module.css";

/** The dark bar above the nav rail, as in the admin app. */
export const TopNav = memo(function TopNav() {
  return (
    <Flex align="center" className={css.topNav} gap="md" w="full">
      <Logo className={css.logo} />
      <Text as="span" className={css.label} fontSize="sm" m="none">
        Partners
      </Text>
    </Flex>
  );
});
